var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/quoted-status.tsx";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "core-js/modules/web.dom-collections.iterator.js";
import classNames from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import StatusMedia from 'soapbox/components/status-media';
import { Stack } from 'soapbox/components/ui';
import AccountContainer from 'soapbox/containers/account-container';
import { useSettings } from 'soapbox/hooks';
import { defaultMediaVisibility } from 'soapbox/utils/status';
import OutlineBox from './outline-box';
import StatusContent from './status-content';
import StatusReplyMentions from './status-reply-mentions';
import SensitiveContentOverlay from './statuses/sensitive-content-overlay';
const messages = defineMessages({
  cancel: {
    "id": "reply_indicator.cancel",
    "defaultMessage": "Cancel"
  }
});

/** Status embedded in a quote post. */
const QuotedStatus = _ref => {
  let {
    status,
    onCancel,
    compose
  } = _ref;
  const intl = useIntl();
  const history = useHistory();
  const settings = useSettings();
  const displayMedia = settings.get('displayMedia');
  const overlay = useRef(null);
  const [showMedia, setShowMedia] = useState(defaultMediaVisibility(status, displayMedia));
  const [minHeight, setMinHeight] = useState(208);
  useEffect(() => {
    if (overlay.current) {
      setMinHeight(overlay.current.getBoundingClientRect().height);
    }
  }, [overlay.current]);

  const handleExpandClick = e => {
    if (!status) return;
    const account = status.account;

    if (!compose && e.button === 0) {
      const statusUrl = "/@".concat(account.acct, "/posts/").concat(status.id);

      if (!(e.ctrlKey || e.metaKey)) {
        history.push(statusUrl);
      } else {
        window.open(statusUrl, '_blank');
      }

      e.stopPropagation();
      e.preventDefault();
    }
  };

  const handleClose = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const handleToggleMediaVisibility = () => {
    setShowMedia(!showMedia);
  };

  if (!status) {
    return null;
  }

  const account = status.account;
  let actions = {};

  if (onCancel) {
    actions = {
      onActionClick: handleClose,
      actionIcon: require('@tabler/icons/x.svg'),
      actionAlignment: 'top',
      actionTitle: intl.formatMessage(messages.cancel)
    };
  }

  return /*#__PURE__*/React.createElement(OutlineBox, {
    "data-testid": "quoted-status",
    className: classNames('cursor-pointer', {
      'hover:bg-gray-100 dark:hover:bg-gray-800': !compose
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    onClick: handleExpandClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(AccountContainer, _extends({}, actions, {
    id: account.id,
    timestamp: status.created_at,
    withRelationship: false,
    showProfileHoverCard: !compose,
    withLinkToProfile: !compose,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(StatusReplyMentions, {
    status: status,
    hoverable: false,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    className: "relative z-0",
    style: {
      minHeight: status.hidden ? Math.max(minHeight, 208) + 12 : undefined
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 115,
      columnNumber: 9
    }
  }, status.hidden && /*#__PURE__*/React.createElement(SensitiveContentOverlay, {
    status: status,
    visible: showMedia,
    onToggleVisibility: handleToggleMediaVisibility,
    ref: overlay,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 128,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(StatusContent, {
    status: status,
    collapsable: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 129,
      columnNumber: 13
    }
  }), (status.card || status.media_attachments.size > 0) && /*#__PURE__*/React.createElement(StatusMedia, {
    status: status,
    muted: compose,
    showMedia: showMedia,
    onToggleVisibility: handleToggleMediaVisibility,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 15
    }
  })))));
};

export default QuotedStatus;